/**
 * Dohvaća scriptu sa zadanog url-a.
 *
 * Koristi browser cache ako je moguće. Neće istu skriptu učitati dva puta.
 *
 * U slučaju kada je skripta već učitana i onload se već pokrenuo, svaki novi poziv loadScript sa istim url-om će biti
 * resolve-an automatski nakon timeouta. Za slučajeve kada je kod prvotnog učitavanja došlo do greške smatramo
 * prihvatljivim da se drugi poziv resolve-a jer će se uvijek vidjeti greška u konzoli od prvog učitavanja.
 *
 * @param string url
 * @param int timeout u milisekundama
 *
 * @return Promise
 */
function loadScript(url, timeout = 1000) {
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`[src="${url}"]`);
        if (existingScript) {
            const originalOnload = existingScript.onload;
            const originalOnerror = existingScript.onerror;

            existingScript.onload = () => {
                originalOnload();
                resolve();
            };
            existingScript.onerror = () => {
                originalOnerror();
                reject();
            };

            setTimeout(resolve, timeout);
        } else {
            const script = document.createElement('script');
            script.src = url;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        }
    });
}

export default loadScript;
